import React, { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Navigate } from 'react-router-dom';
import Message from './Message';

const LoginAccess = () => {
  const [message, setMessage] = useState(false);
  const { loginWithRedirect, isAuthenticated } = useAuth0();

  return (
    <div className='flex flex-col items-center justify-center h-screen'>
      {isAuthenticated && (
        <Navigate
          to='/menu'
          replace={true}
        />
      )}
      <div className='h-screen w-full flex justify-center items-center'>
        <div className='w-full max-w-lg bg-white rounded-lg p-5 text-center flex flex-col'>
          <img
            src='./logo_arbitraje.png'
            alt='Logo'
            className='w-64 mx-auto'
          />
          <h2 className='block text-gray-600 font-medium text-xl mb-2'>
            Ingreso de solicitud
          </h2>
          <p className='text-gray-600'>
            Para acceder a la plataforma ingrese sus credenciales o regístrese.
          </p>
          <button
            onClick={() => {
              // console.log('first');
              if (message) {
                loginWithRedirect();
              } else {
                alert('Debe aceptar los términos y condiciones');
              }
              // <Navigate
              //   to='/menu'
              //   replace={true}
              // />;
            }}
            className='bg-[#BC1F28] text-white px-10 py-2 mt-5 rounded-md hover:bg-red-800'
          >
            Acceder
          </button>
        </div>
      </div>
      <Message
        setMessage={setMessage}
        message={message}
      />
    </div>
  );
};

export default LoginAccess;
